'use client'

import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister'

import { APP_DATA_VERSION } from './constants'

const STORAGE_KEY_PREFIX = 'pgee-cache'

const EMPTY_DEHYDRATED = { queries: [], mutations: [] }

function normalizeVersion(version?: string | null): string {
  if (!version) return 'default'
  return version.trim() || 'default'
}

export function getBootstrapStorageKey(
  userId: string,
  gamificationVersion?: string | null
): string {
  const normalizedVersion = normalizeVersion(gamificationVersion)
  return `${STORAGE_KEY_PREFIX}-${userId}-v${APP_DATA_VERSION}-g${normalizedVersion}`
}

export function createBootstrapPersister(
  userId: string,
  gamificationVersion?: string | null
) {
  const key = getBootstrapStorageKey(userId, gamificationVersion)
  return createAsyncStoragePersister({
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    key,
    deserialize: (cachedString: string) => {
      try {
        const parsed = JSON.parse(cachedString) as {
          version?: string
          buster?: string
          timestamp?: number
          clientState?: { queries: unknown[]; mutations: unknown[] }
        }
        if (
          typeof parsed.version === 'string' &&
          parsed.version !== APP_DATA_VERSION
        ) {
          if (typeof window !== 'undefined') {
            window.localStorage.removeItem(key)
          }
          return {
            buster: '',
            timestamp: Date.now(),
            clientState: EMPTY_DEHYDRATED
          }
        }
        return {
          buster: parsed.buster ?? '',
          timestamp: parsed.timestamp ?? Date.now(),
          clientState: parsed.clientState ?? EMPTY_DEHYDRATED
        }
      } catch {
        if (typeof window !== 'undefined') {
          window.localStorage.removeItem(key)
        }
        return {
          buster: '',
          timestamp: Date.now(),
          clientState: EMPTY_DEHYDRATED
        }
      }
    },
    serialize: (client: {
      buster: string
      timestamp: number
      clientState: { queries: unknown[]; mutations: unknown[] }
    }) =>
      JSON.stringify({
        ...client,
        version: APP_DATA_VERSION
      })
  })
}
